import axios from "axios";
import { getToken } from "../../../config/getToken";
import { env } from "../../../env";

/** Obtiene los comercios para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de comercios. */
export async function GetTraders(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/traders`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene los EAN de puntos de venta para filtros.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de EAN. */
export async function GetEanPointSales(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/eans/pointsales`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene los puntos de venta para filtros.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de puntos de venta. */
export async function GetPointSales(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/pointsales`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene los formatos para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de formatos. */
export async function GetFormats(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/formats`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene los departamentos (geografía nivel 1) para filtros.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de departamentos. */
export async function GetDepartments(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/levels1/geographies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene las ciudades (geografía nivel 4) para filtros.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de ciudades. */
export async function GetCities(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/levels4/geographies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene los canales para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de canales. */
export async function GetChannels(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/channels`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene las categorías (nivel 1) para filtros.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de categorías. */
export async function GetCategories(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `/filters/dynamicreports/level1/categories`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene los productos para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de productos. */
export async function GetProducts(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/products`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene el nivel 1 de Salesforce para filtros.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de niveles de Salesforce. */
export async function GetSalesForceLevelOne(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/levels1/salesforce`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene las marcas para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de marcas. */
export async function GetBrands(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/brands`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene los colores para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de colores. */
export async function GetColors(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/colors`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene las tallas para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de tallas. */
export async function GetSizes(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/sizes`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
/** Obtiene los vendedores para filtros de reportes dinámicos.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de vendedores. */
export async function GetSalesMan(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `filters/dynamicreports/salesman`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Genera un reporte dinámico.
 * @param {Object} data - Datos del reporte.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function GenerateDynamicReport(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `dynamicreports`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene un reporte dinámico pivotado por EAN.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Reporte dinámico pivotado. */
export async function GetDynamicReportByEan(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    data: data,
    url: `dynamicreports/pivote`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Edita un reporte dinámico existente.
 * @param {Object} data - Datos actualizados del reporte.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function EditDynamicReport(data) {
  const token = await getToken();
  return axios({
    method: "PUT",
    data: data,
    url: `dynamicreports`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}